import { Actions, ofType } from '@ngrx/effects'
import { NotificationService } from './../../../../core/notification.service'
import { Store } from '@ngrx/store'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { configurationOptionActions } from '../../configuration-option.actions'
import { AppState } from 'src/app/core/core.state'
import {
  catchError,
  take,
  timeout
} from 'rxjs/operators'
import { Observable, of } from 'rxjs'
import { configurationOptionSelectors } from '../../configuration-option.selectors'
import { ConfigurationOptionService } from '../../configuration-option.service'

@Component({
  selector: 'employee-contract-config-card',
  templateUrl: './employee-contract-config-card.component.html',
  styleUrls: ['./employee-contract-config-card.component.scss']
})
export class EmployeeContractConfigCardComponent implements OnInit {
  @Output() onSubmit = new EventEmitter<any>()

  public form: UntypedFormGroup
  public isCollapsed = true
  public formValues$: Observable<any>
  public configContracts: any

  constructor(
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private notificationService: NotificationService,
    private actions$: Actions,
    private configOptionService: ConfigurationOptionService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      description: [null, []],
      externalContractNumber: [null, []],
      startDate: [null, []],
      endDate: [null, []],
      salary: [null, []],
      vat: [null, []],
      contractHours: [null, []],
      hoursPerWeek: [null, []],
      vacationHours: [null, []],
      nationalHolidayHours: [null, []],
      debtorPersonId: [null, []],
      descriptionRequired: [null, []],
      externalContractNumberRequired: [null, []],
      startDateRequired: [null, []],
      endDateRequired: [null, []],
      salaryRequired: [null, []],
      vatRequired: [null, []],
      contractHoursRequired: [null, []],
      hoursPerWeekRequired: [null, []],
      vacationHoursRequired: [null, []],
      nationalHolidayHoursRequired: [
        this.configContracts?.value
          ? JSON.parse(this.configContracts?.value)
              ?.nationalHolidayHoursRequired
          : false,
        []
      ],
      debtorPersonIdRequired: [null, []]
    })

    this.formValues$ = this.store.select(
      configurationOptionSelectors.selectByKey,
      'employeeContractConfig'
    )
    this.formValues$.pipe(take(1)).subscribe((formValues) => {
      if (formValues?.value) {
        this.configContracts = {
          ...JSON.parse(formValues?.value),
          id: formValues.id
        }
      }
    })
  }
  onFormSubmit(): void {
    if (this.configContracts) {
      this.store.dispatch(
        configurationOptionActions.updateOneById({
          id: this.configContracts.id,
          params: {
            value: JSON.stringify(this.form.value)
          }
        })
      )
    } else {
      this.store.dispatch(
        configurationOptionActions.createOne({
          entity: {
            key: 'employeeContractConfig',
            value: JSON.stringify(this.form.value)
          }
        })
      )
    }
    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }
  public patchValueForm(field, value: boolean) {
    let patchValue = {}

    patchValue[field] = value
    this.form.patchValue(patchValue)
  }
}
